
import React, { useEffect, useState } from 'react';

import './HintModal.css';

import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

import { useTranslation } from 'react-i18next';

const HintModal = ({ active, callback }) => {
  const { t } = useTranslation();

  const [show, setShow] = useState(false);

  useEffect(() => {
    if (active) {
      setShow(true);
    }
  }, [active]);

  useEffect(() => {
    callback(show);
  }, [show, callback]);

  const handleClose = () => {
    setShow(false);
  };

  const openLink = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <Dialog
      visible={show}
      onHide={handleClose}
      header={t('hint.title') || 'Ajuda'}
      className="HintModal"
      modal
      draggable={false}
      resizable={false}
      dismissableMask={false}
      closable
      footer={
        <div className="HintModalFooter">
          <Button
            severity="secondary"
            raised
            icon="pi pi-times"
            className="CloseBtn"
            onClick={handleClose}
          >
            {t('common.close') || 'Fechar'}
          </Button>
        </div>
      }
    >
      <div className="ContainerHint">

        <div className="HintIntroduction">
          <p>{t('hint.intro')}</p>

          <p>{t('hint.modulesIntro')}</p>

          <p>
            <span>{t('hint.module1.title')}</span>{' '}
            {t('hint.module1.text')}
          </p>

          <p>
            <span>{t('hint.module2.title')}</span>{' '}
            {t('hint.module2.text')}
          </p>

          <p>
            <span>{t('hint.module3.title')}</span>{' '}
            {t('hint.module3.text')}
          </p>

          <p>
            <span>{t('hint.needHelp')}</span>
          </p>
        </div>

        <div className="LinkMenu">

          <div className="LinkMenuGrid">

            <Button
              label={t('hint.links.atlas')}
              icon="pi pi-map"
              outlined
              onClick={() =>
                openLink(
                  'https://www.sema.ce.gov.br/atlas-costeiro-e-marinho-do-estado-do-ceara-2023/'
                )
              }
            />

            <Button
              label={t('hint.links.ccma')}
              icon="pi pi-globe"
              outlined
              onClick={() =>
                openLink('https://www.sema.ce.gov.br/89965-2/')
              }
            />

            <Button
              label={t('hint.links.zeec')}
              icon="pi pi-map-marker"
              outlined
              onClick={() =>
                openLink(
                  'https://www.sema.ce.gov.br/gerenciamento-costeiro/zoneamento-ecologico-economico-da-zona-costeira-zeec/documentos-previos-para-consulta-publica-do-zeec/'
                )
              }
            />

            <Button
              label={t('hint.links.ceuc')}
              icon="pi pi-chart-bar"
              outlined
              onClick={() =>
                openLink(
                  'https://app.powerbi.com/view?r=eyJrIjoiMzYyMzQ2ZjYtZDQyMS00NjlmLTgyODYtNTc3ODMzMzY5ZjU2IiwidCI6ImY2MjAxZmQxLWFlMzctNGZlMS1hZDJjLTUwNTc3ZTJmYTEzNiJ9&pageName=bb99d8fd3419fdc35983'
                )
              }
            />

            <Button
              label={t('hint.links.guia')}
              icon="pi pi-book"
              outlined
              onClick={() =>
                openLink(
                  'https://drive.google.com/file/d/1ZUfe776rLGXmxt_VL89vnFH3C-nLPj8E/view'
                )
              }
            />

            <Button
              label={t('hint.links.manualDados')}
              icon="pi pi-database"
              outlined
              onClick={() =>
                openLink(
                  'https://drive.google.com/file/d/1hozOlnfeISOOhAfAvEhaA3cgQFebXWCL/view'
                )
              }
            />

            <Button
              label={t('hint.links.faq')}
              icon="pi pi-question-circle"
              outlined
              onClick={() => openLink('/portal/faq.html')}
            />

            <Button
              label={t('hint.links.versao')}
              icon="pi pi-info-circle"
              outlined
              onClick={() => openLink('/portal/versioning.html')}
            />

            <Button
              label={t('hint.links.manual')}
              icon="pi pi-file-pdf"
              outlined
              onClick={() => openLink('/portal/manual.pdf')}
            />

          </div>

        </div>

        <div className="HintTerms">
          <p>
            {t('hint.terms1')}{' '}

            <a
              className="TermLink"
              href="/portal/termos_e_condicoes_de_uso_pedea.pdf"
              target="_blank"
              rel="noreferrer"
            >
              {t('hint.termsLink')}
            </a>{' '}

            {t('hint.and')}{' '}

            <a
              className="TermLink"
              href="/portal/aviso_privacidade_pedea.pdf"
              target="_blank"
              rel="noreferrer"
            >
              {t('hint.privacyLink')}
            </a>.
          </p>
        </div>

      </div>
    </Dialog>
  );
};

export default HintModal;

